var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pco-config"},[(_vm.statusGeral !== "")?[_c('RF-Status',{attrs:{"cpntStatus":_vm.statusGeral,"cpntTamanho":5}})]:(_vm.statusGeral === "")?[_c('RF-Aba',{attrs:{"cpntButtons":_vm.buttons}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }